import { getI18n } from '@/plugins/i18n'

import { usePortalStore } from '@/stores/portal.store'
import { useWebSiteStore } from '@/stores/web-site.store'

export const sortValidationsBySeverity = (validations) =>
  [...(validations || [])].sort((a, b) => {
    if (a.validation_type == null && b.validation_type == null) return 0
    if (a.validation_type == null) return 1
    if (b.validation_type == null) return -1
    return a.validation_type - b.validation_type
  })

export const worstValidationType = (validations) => {
  const worst = sortValidationsBySeverity(validations)[0]
  return worst && worst.validation_type != null ? worst.validation_type : null
}

export const getFieldValidation = (validations, dataField) => {
  if (!dataField) return null
  return sortValidationsBySeverity((validations || []).filter(v => v.validation_field === dataField))[0] ?? null
}

export const hasValidationControls = (rows) => (rows || []).some(row => (row.validations || []).some(v => v.validation_control != null))

export const useImportRowValidation = () => {
  const i18n = getI18n()
  const portalStore = usePortalStore()
  const webSiteStore = useWebSiteStore()

  const validationTypes = portalStore.validationTypes

  const validationColor = (validationType) => {
    if (validationType === validationTypes.ERROR) return 'var(--q-negative)'
    if (validationType === validationTypes.WARNING) return 'var(--q-warning)'
    return 'var(--q-positive)'
  }

  const validationLabel = (validation) => validation.validation_control ? webSiteStore.getLocalizedImportRowValidationMessagesByControl(validation.validation_control)?.[0]?.name : i18n.t('common.importRowValidation.no_validation')
  const validationTooltip = (validation) => validation.validation_type === validationTypes.ERROR ? `${i18n.t('common.importRow.blockingValidation')}: ${validationLabel(validation)}` : `${i18n.t('common.importRow.availableOption')}: ${validationLabel(validation)}`

  const rowValidationsTooltip = (validations) => sortValidationsBySeverity((validations || []).filter(v => v.validation_control != null)).map(validationTooltip).join('\n')

  return {
    validationTypes,
    validationColor,
    validationLabel,
    validationTooltip,
    rowValidationsTooltip,
    sortValidationsBySeverity,
    worstValidationType,
    getFieldValidation,
    hasValidationControls,
  }
}
